import {SelectField} from './select-field';
import {GridWidgetFilter} from './grid-widget-filter';
import {InverseMultiSelectFilter} from './inverse-multi-select-filter';
import {OrderedMap} from '../ordered-map';
import {DisableFilterOption} from './grid-widget-data-field';
import {MultiSelectField} from './multi-select-field';
export class InverseMultiSelectField extends SelectField {

  //This is the number of check boxes that can show up on a multiselect filter in the UI before it changes to the dropdown.
  //Brian thinks the right number is 5, but the designers have said otherwise.
  //I've decided to make this a configurable field so it will be easy to update if we get feedback asking for the threshold
  //to be larger.
  popupThreshold = 1;

  constructor(name: string,
              objectLookup: string | ((Object) => any),
              title: string,
              selectOptions: OrderedMap<any>,
              sortOrder?: any) {
    super(name, objectLookup, title, selectOptions, sortOrder);

    //This thing isn't going to work in the simple filters for the original implementation.
    //We may want to enable this functionality later.
    this.filterDisabled = DisableFilterOption.simpleOnly;
  }

  getFilterInstance(): GridWidgetFilter {
    return new InverseMultiSelectFilter(this);
  }

  resolveAsString(dataRow: any): string {
    return MultiSelectField.multiSelectResolveAsString(this.resolve(dataRow), this.selectOptions);
  }
}
